/**
 * @param {Object} options
 * @param {"binance"|"gate"} options.exchange
 * @param {"BRL"|"BOB"} options.fiat
 * @param {"BUY"|"SELL"} options.side
 * @param {number[]} options.prices
 * @param {string} [options.asset]
 * @param {string} [options.fetchedAt]
 * @param {boolean} [options.experimental]
 * @param {any} [options.raw]
 * @returns {import("./types").P2PQuote}
 */
export function buildP2PStats({
  exchange,
  fiat,
  side,
  prices,
  asset = "USDT",
  fetchedAt = new Date().toISOString(),
  experimental = false,
  raw,
}) {
  const normalized = Array.isArray(prices)
    ? prices.filter((value) => typeof value === "number" && Number.isFinite(value))
    : [];
  if (!normalized.length) {
    if (import.meta.env.MODE === "development") {
      console.debug(`[P2P] ${exchange} ${fiat} ${side} sem preços válidos`, {
        raw,
        candidatePrices: prices,
      });
    }
    throw new Error(`Sem preços válidos para ${exchange} ${fiat} ${side}`);
  }
  const sorted = [...normalized].sort((a, b) => a - b);
  const best = sorted[0];
  const mid = Math.floor(sorted.length / 2);
  const median =
    sorted.length % 2
      ? sorted[mid]
      : (sorted[mid - 1] + sorted[mid]) / 2;
  const avg = sorted.reduce((acc, value) => acc + value, 0) / sorted.length;
  return {
    exchange,
    fiat,
    asset,
    side,
    best,
    median,
    avg,
    samples: sorted.length,
    fetchedAt,
    raw,
    experimental: experimental || undefined,
  };
}
